import styled, { css } from 'styled-components';
import Button from 'components/Button';

export const SkipIntroStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const SkipIntroButton = styled(Button)`
  position: absolute;
  height: 39px;
  right: 50px;
  bottom: 100px;
  padding: 10px 24px 10px 24px;
  z-index: 2;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  font-weight: 500;
  color: white;

  &:hover {
    background: white;
    color: black;
  }

  &:active {
    background: rgba(255, 255, 255, 0.5);
  }

  ${({ isMobile }) =>
    isMobile &&
    css`
      height: 28px;
      padding: 10px 20px 10px 20px;
      right: 15px;
      background: rgba(68, 68, 68, 0.6);

      &:active,
      &:hover {
        background: rgba(255, 255, 255, 0.2);
        -webkit-text-fill-color: white;
      }
    `};
`;

export const SkipIntroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 1s ease-in-out;
`;
